import {createFeature, StoreModule} from '@ngrx/store';
import {StoreKeys} from '../../../models/store-keys';
import {wkfSupervisionSearchResultReducer} from './reducer/wkf-supervision-search-result.reducer';

export const wkfSupervisionSearchResultStoreConfig = StoreModule.forFeature(
  createFeature({
    name: StoreKeys.WKF_SUPERVISION_SEARCH_RESULT,
    reducer: wkfSupervisionSearchResultReducer
  })
);
